export default class Amount {
    public value: number;
    public currencyCode: string = 'SEK';
}
